export default "__VITE_ASSET__CalbdmXq__"